<template lang="pug">
.ba(
	v-show="(!isApp && !showNav && (this.$data.isIos || this.$data.isAndroid) && !this.$data.banner_closed)"
	:class="[{'ba--hide': banner_hide}]"
)
	.ba-main(@click="goToStore")
		.ba-main__img
			img(src="/acb-logo-white.svg",
			alt="acb app icon"
			)
		span.ba-main__title ¡DESCÁRGATE LA APP DE LA ACB!
		img.ba-main__store(
			:src= "isIos ? '/app-store-badge.svg' : '/google-play-badge.png'", 
			alt="badge store" 
		)
	.ba__close(@click="closeBanner" role="button")
		i: font-awesome-icon(icon="times")
</template>

<style lang="sass">
.ba
	--logo-size: 40px

	position: fixed
	z-index: 99
	bottom: 0
	left: 0
	width: 100%
	box-sizing: border-box
	display: flex
	justify-content: center
	filter: drop-shadow(6px 6px 18px rgba(0,0,0,.5))
	transform: translateY(0)
	transition: transform 1s
	+breakpoint(medium)
		display: none
	
	&-main
		padding: 1rem
		box-sizing: border-box
		background-color: $white
		width: 100%
		display: grid
		grid-gap: 1rem
		grid-auto-flow: column
		align-items: center
		grid-template-columns: var(--logo-size) auto calc(var(--logo-size)*3)
		&__img
			height: var(--logo-size)
			border-radius: 1rem
			background-color: #000
			img
				object-fit: contain
				width: 100%
				height: 100%
				padding: 0.5rem
				box-sizing: border-box
		&__store
			// width: calc(var(--logo-size)*2)
			// height: var(--logo-size)
			width: 100%
		
		&__title
			// +h3
			font-size: 1.2rem
			line-height: 1em
			font-weight: $wblack

	&--hide
		transform: translateY(200%)

	&__close
		position: absolute
		background-color: rgba($white,0.8)
		backdrop-filter: blur(2px)
		width: 2.5rem
		height: 2.5rem
		top: 0
		right: 0
		box-sizing: border-box
		display: flex
		justify-content: center
		align-items: center
		transform: translateY(-100%)
		font-size: 1.2rem



</style>

<script>
export default {
	name: "BannerAcbApp",
	data() {
		return {
			banner_closed: false,
			banner_hide: false,
			lastScroll: 0,
			scrollUp: 0,
			scrollDown: 0,
			banner_already_closed: false,
			isPhone: null,
			isAndroid: false,
			isIos: false
		};
	},
	computed: {
		showNav() {
			return this.$store.state.general.showNav
		},
		isApp() {
			return this.$store.state.general.isApp
		},

	},
	methods: {

		checkDeviceIsPhone() {
			// if((navigator.userAgent.toLowerCase().indexOf("android") > -1) || (navigator.userAgent.toLowerCase().indexOf("iphone") > -1)){
			// 	this.$data.isPhone = true;
			// }
			if (navigator.userAgent.toLowerCase().indexOf("android") > -1) {
				this.$data.isAndroid = true;
			} else if (navigator.userAgent.toLowerCase().indexOf("iphone") > -1) {
				this.$data.isIos = true;
			}
		},
		goToStore() {
			if (navigator.userAgent.toLowerCase().indexOf("android") > -1) {
				window.open("http://play.google.com/store/apps/details?id=com.acb.www");
			}
			if (navigator.userAgent.toLowerCase().indexOf("iphone") > -1) {
				window.open("https://apps.apple.com/es/app/acb/id437202587");
			}
			this.closeBanner()
		},
		bannerAlreadyClosed() {
			var name = 'close_banner_app_acb';
			var nameEQ = name + "=";
			var ca = document.cookie.split(';');
			var value;
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) == 0) value = c.substring(nameEQ.length, c.length);
			}
			if (value) {
				this.$data.banner_closed = true;
			}
		},
		closeBanner() {
			var exdate = new Date();
			var numberDaysToExpire = 21;
			exdate.setDate(exdate.getDate() + numberDaysToExpire);

			document.cookie = 'close_banner_app_acb'
				+ "=" + 'true'
				+ "; expires=" + exdate.toUTCString()
				;
			this.$data.banner_closed = true;
		},

		handleScroll(event) {
			let st
			let treshold = 300

			if (event.currentTarget == window) {
				st = window.scrollY
			} else {
				st = event.target.scrollTop;
			}

			if (st > this.lastScroll) {
				this.$data.scrollUp = st
			} else {
				this.$data.scrollDown = st
			}
			this.lastScroll = st <= 0 ? 0 : st;

			if (this.$data.scrollUp != null) {
				if (this.$data.scrollUp - st > treshold) {
					this.$data.scrollUp = null
					this.$data.banner_hide = !this.$data.banner_hide
				}
			}
			if (this.$data.scrollDown != null) {
				if (st - this.$data.scrollDown > treshold) {
					this.$data.scrollDown = null
					this.$data.banner_hide = !this.$data.banner_hide
				}
			}



		}
	},

	mounted() {
		let scrollwrapper

		if (this.$route.name.split('.').includes('home')) {
			scrollwrapper = window
		} else {
			scrollwrapper = document.getElementsByClassName("ge-cnt-body")[0]
		}
		scrollwrapper.addEventListener('scroll', this.handleScroll);

		this.bannerAlreadyClosed()
		this.checkDeviceIsPhone()

	}

}


</script>
